import React from 'react';

const NavigationMenuLink = ({ contentLink }) => {
    const additionClass = contentLink.attributes
        ? contentLink.attributes.cssValue
        : '';
    const selectedClass = contentLink.isSelected ? 'navbar__link--selected' : '';

    return (
        <li className={`navbar__item ${contentLink.name === "Recept" ? "receptLink" : ""}`}>
            <a
                className={`navbar__link ${selectedClass} ${additionClass}`}
                href={contentLink.url || '#'}
                dangerouslySetInnerHTML={{ __html: contentLink.name }}
            ></a>
        </li>
    );
};

export default NavigationMenuLink;